export const HOME_PAGE = {
  CTA_BUTTON: 'Try new home',
  SUMMARY: {
    TASKS_REMAINING: 'Tasks remaining',
    COMPLETED_CONTROLS: 'Completed controls',
    TOTAL_COMPLIANCE: 'Total Compliance',
  },
  TASKS: {
    TITLE: 'Tasks',
    TOTAL: 'Total',
    COMPLETION: 'COMPLETION',
    VIEW_ALL: (count: number) => `View all ${count} tasks`,
  },
  DOCUMENTATION: {
    TITLE: 'Documentation',
  },
  STANDARDS: {
    SHOW_LESS: 'Show less',
    VIEW_ALL: 'View all standards',
    REQUEST: 'Request',
  },
}

export const NEW_HOME = {
  TITLE: 'Home',
  SUBTITLE: 'Audit readiness and security posture',
  TABS: {
    OVERVIEW: 'Overview',
    COMPLIANCE: 'Compliance',
    SECURITY: 'Security',
  },
  MANAGER: {
    TITLE: 'Security manager',
    TEAM: 'Qalea team',
    ROLE: 'Your security manager',
    NOTES: 'Shared notes',
    SLACK: 'Open Slack',
    CONTACT: 'Contact',
  },
  EXECUTIVE_REPORT: {
    BUTTON: 'Executive report',
    TITLE: 'Executive report',
    STEPS: [
      'Submit a request for the executive report',
      'The report is generated from your latest compliance and security data',
      'Once complete, it is sent to your email address automatically',
    ],
    CANCEL: 'Cancel',
    REQUEST: 'Submit request',
    SUBMITTING: 'Submitting request',
    SENT_TITLE: 'Request submitted',
    SENT_DESCRIPTION:
      'Your executive report is being generated. It will be delivered to your email address once it is complete.',
    DONE: 'Close',
  },
  NOTIFICATIONS: {
    TITLE: 'Notifications',
    MARK_ALL_READ: 'Mark all as read',
    FILTERS: { all: 'All', task: 'Tasks', finding: 'Findings', update: 'Updates' },
    GROUPS: {
      task: 'Task manager',
      finding: 'New findings',
      update: 'Updates',
    },
    OPEN_TASKS: 'Open Task manager',
  },
  STANDARDS: 'Standards',
  KPIS: {
    READINESS: 'Audit readiness',
    CONTROLS: 'Controls implemented',
    EVIDENCE: 'Evidence accepted',
    DOCUMENTATION: 'Documents approved',
    BLOCKERS: 'Audit blockers',
    COMPLETED_TASKS: 'Tasks completed',
  },
  TIMELINE: {
    TITLE: 'Certification timeline',
    TODAY: 'Today',
    PROGRESS: 'Progress',
    INTERNAL: 'Internal audit',
    EXTERNAL: 'External audit',
    CONTROLS: 'controls',
    DETAILS: 'Toggle framework details',
    BLOCKERS: (count: number) => `${count} blockers`,
    MORE: (count: number) => `+${count} more`,
  },
  TASKS: {
    TITLE: 'Pending tasks',
    VIEW_ALL: 'View all tasks',
    TODAY: 'Today',
    TOMORROW: 'Tomorrow',
    OVERDUE: 'Overdue',
    UNASSIGNED: 'Unassigned',
    EMPTY: 'No pending tasks',
  },
  SECURITY: {
    TITLE: 'Security posture',
    CRITICAL: (count: number) => `${count} critical`,
    CRITICAL_24H: (count: number) => `${count} critical (24h)`,
    ALL_FIXED: 'All fixed',
    LAST_SCAN: 'Last scan',
    SCAN: (date: string) => `Scan: ${date}`,
    RESOLVED: (percent: number, fixed: number, total: number) => `${percent}% resolved · ${fixed} of ${total}`,
    CHART_CAPTIONS: {
      RESPONSES: 'Responses per day',
      ALERTS: 'Alerts per day',
    },
    ALL_ALERTS: 'All alerts',
    CHART: { RESPONSES: 'auto responses', FIXED: 'fixed', OPEN: 'open', TOTAL: 'Total' },
    ROWS: { MONITORING: 'Monitoring', POSTURE: 'Exposure' },
    SEE_DETAILS: 'View module',
    GO_TO: (module: string) => `Go to ${module}`,
    CARDS: {
      EDR: 'EDR',
      SIEM: 'SIEM',
      APPSEC: 'AppSec',
      EASM: 'EASM',
      CLOUD: 'Cloud',
      VULNERABILITIES: 'Vulnerabilities',
    },
    CAPTIONS: {
      EDR: 'Threats blocked automatically · 30 days',
      SIEM: 'Alerts · 30 days',
      APPSEC: 'Open findings',
      EASM: 'External findings',
      CLOUD: 'Misconfigurations',
      VULNERABILITIES: 'Open CVEs',
    },
    POSITIVE: {
      EDR: 'Endpoints protected',
      SIEM: 'Logs collected · 24h',
    },
    UNITS: {
      APPSEC: 'open findings',
      EASM: 'open external findings',
      CLOUD: 'open misconfigurations',
      VULNERABILITIES: 'open CVEs',
    },
  },
}
